import { render, staticRenderFns } from "./nevleft.vue?vue&type=template&id=bcad2546&"
import script from "./nevleft.vue?vue&type=script&lang=js&"
export * from "./nevleft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports